import React, { useState, useEffect } from 'react';
import {
  Row, Col, Spin, notification,
} from 'antd';
import {
  useNavigate, useLocation,
} from 'react-router-dom';
import ColetaPorTalhoesDetails from '../details/Details';
import ColetaPorTalhoesSummary from '../summary/Summary';
import SuccessSolicitation from '../../../serviceComponents/successSolicitation/SuccessSolicitation';
import { getUserType } from '../../../../../utils/users';

const ColetaPorTalhoesFlow = (): JSX.Element => {
  const initialParameters = (): any => ({
    isSkippingSteps: false,
    serviceList: [],

    selectedService: {
      id: 0,
      idCode: '',
      name: '',
      description: '',
      types: [],
    },

    selectedType: {
      id: 0,
      idCode: '',
      name: '',
      subtypes: [],
    },

    selectedProperty: {
      id: '',
      name: '',

      location: {
        lat: null,
        lon: null,
      },

      registeredOn: '',
      matriculation: '',
    },

    selectedMatriculation: getUserType() === 'COOPERCITRUS' ? null : 'COOPERATIVE',

    selectedOwner: {
      id: '',
      name: '',
    },

    serviceTypeDynamicFields: [],
    serviceSubtypeDynamicFields: [],
    talhoesSelecionados: [],
  });

  const [currentPage, setCurrentPage] = useState<number>(-1);
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const locationObject = useLocation();
  const [serviceRequestParameters, setServiceRequestParameters] = useState(initialParameters());
  const [initialRequestParameters, setInitialRequestParameters] = useState(initialParameters());

  const removeSelectedField = (id): void => {
    setServiceRequestParameters((previous) => {
      return ({
        ...previous,
        talhoesSelecionados: previous.talhoesSelecionados.filter((v) => v.id !== id),
      });
    });
  };

  useEffect(() => {
    setLoading(true);

    if (!locationObject.state?.serviceRequestParams) {
      notification.error({
        message: 'Erro',
        description: 'Houve um erro ao solicitar o serviço.',
      });

      navigate('/service/new');
      setLoading(false);

      return;
    }

    setServiceRequestParameters(locationObject.state?.serviceRequestParams);
    setInitialRequestParameters(locationObject.state?.serviceRequestParams);
    setCurrentPage(0);
    setLoading(false);
  }, []);

  const previousPage = (parameters): void => {
    if (currentPage === 0) {
      navigate('/service/new', {
        state: {
          skipToPage: 3,
          serviceID: serviceRequestParameters.selectedService.id,
          matriculation: serviceRequestParameters.matriculation,
          allServiceParameters: serviceRequestParameters,
        },
      });
      return;
    }

    setServiceRequestParameters((previous) => {
      return ({
        ...previous,
        ...parameters,
      });
    });
    setCurrentPage((previous) => previous - 1);
  };

  const nextPage = (parameters): void => {
    setServiceRequestParameters((previous) => {
      return ({
        ...previous,
        ...parameters,
      });
    });
    setCurrentPage((previous) => previous + 1);
  };

  return (
    <div className="ColetaPorTalhoesFlow">
      <Spin tip="Carregando..." spinning={loading}>
        <Row>
          <Col span={24}>
            <div style={{ display: currentPage === 0 ? 'block' : 'none' }}>
              {
                currentPage === 0
                && (
                  <ColetaPorTalhoesDetails
                    previousPage={previousPage}
                    nextPage={nextPage}
                    serviceRequestParameters={serviceRequestParameters}
                    removeSelectedField={removeSelectedField}
                  />
                )
              }
            </div>

            <div style={{ display: currentPage === 1 ? 'block' : 'none' }}>
              {
                currentPage === 1
                && (
                  <ColetaPorTalhoesSummary
                    previousPage={previousPage}
                    nextPage={nextPage}
                    serviceRequestParameters={serviceRequestParameters}
                    removeSelectedField={removeSelectedField}
                  />
                )
              }
            </div>

            <div style={{ display: currentPage === 2 ? 'block' : 'none' }}>
              <SuccessSolicitation
                previousPage={previousPage}
                params={serviceRequestParameters}
              />
            </div>
          </Col>
        </Row>
      </Spin>
    </div>
  );
};

ColetaPorTalhoesFlow.propTypes = {};
ColetaPorTalhoesFlow.defaultProps = {};

export default ColetaPorTalhoesFlow;
